import styled from "@emotion/styled";
import { Container, Grid, Typography } from "@mui/material";

const PartnerWrapper = styled(Container)`
    background-image:url("./assets/partner-bg.png");
    background-size:cover;
    background-position:center;
    background-repeat:no-repeat;
    background-color:#000B29;
    padding-top:100px;
    padding-bottom:100px;
    @media(max-width:1100px) and (min-width: 768px){
        padding-top:40px;
    }
    @media(max-width:749px){
        padding-top:20px;
        padding-bottom:30px;
        background-size:contain;
        background-position:center;
    }
    @media (max-width: 1100px){
        background-size:contain;
    }
    @media (min-width: 2000px){
        padding-top:280px;
        padding-bottom:280px;
    }
`
const Heading = styled(Typography)`
    font-size:25px;
    font-family:Emulogic-zrEw;
    font-weight:400;
    text-transform:uppercase;
    color:#fff;
    text-align:center;
`
const LinksWrapper = styled.a`
    display:flex;
    align-items:center;
    @media (min-width: 900px){
        justify-content:center;
    }
`
const P = styled.p`
    color:#fff;
    font-family:Emulogic-zrEw;
    font-size:16px;
    font-weight:400;
    margin-left:10px;
    @media (max-width:350px){
        font-size:11px;
        margin-left:5px;
    }
    @media(max-width: 900px) and (min-width: 350px){
        font-size:12px;
    }
`
const LinksImg = styled.img`
    height:60px;
    width:60px;
    @media(max-width: 900px) and (min-width: 350px){
        height:35px;
        width:35px;
    }
    @media (max-width:350px){
        height:25px;
        width:25px;
    }
`
const LinksGrid = styled(Grid)`
    margin-top:100px;
    margin-bottom:60px;
    display:flex;
    align-items:center;
    @media (min-width: 900px){
        justify-content:center;
    }
    @media(max-width: 749px){
        margin-top:20px;
        padding-bottom:50px;
    }
`
function Partner() {
    return (
        <PartnerWrapper maxWidth="xxl" id="partners">
            <Grid container>
                <Grid item xs={12}>
                    <Heading variant="h1" data-aos="zoom-in">Partners</Heading>
                </Grid>
            </Grid>
            <LinksGrid container>
                <Grid item xs={6} sm={3} xl={2}>
                    <LinksWrapper  data-aos="zoom-in">
                        <LinksImg src="./assets/unity-logo.png" />
                        <P>Unity 3D</P>
                    </LinksWrapper>
                </Grid>
                <Grid item xs={6} sm={3} xl={2}>
                    <LinksWrapper data-aos="zoom-in">
                        <LinksImg src="./assets/etherscan-logo.png" />
                        <P>Etherscan</P>
                    </LinksWrapper>
                </Grid>
                <Grid item xs={6} sm={3} xl={2}>
                    <LinksWrapper data-aos="zoom-in">
                        <LinksImg src="./assets/uni-logo.png" />
                        <P>Uniswap</P>
                    </LinksWrapper>
                </Grid>
                <Grid item xs={6} sm={3} xl={2}>
                    <LinksWrapper data-aos="zoom-in">
                        <LinksImg src="./assets/dex-logo.png" />
                        <P>Dextools</P>
                    </LinksWrapper>
                </Grid>
            </LinksGrid>
        </PartnerWrapper>
    );
}

export default Partner;